import RecordRTC, { StereoAudioRecorder } from 'recordrtc'

export default class RTCRecorder {
  constructor(stream) {
    this.stream = stream
    this.adapter = this.getRecordRTC()

    const AudioContext = window.AudioContext || window.webkitAudioContext
    this.context = new AudioContext()
  }

  getRecordRTC() {
    return RecordRTC(this.stream, {
      type: 'audio',
      mimeType: 'audio/wav',
      recorderType: StereoAudioRecorder,
    })
  }

  getStream() {
    return this.stream
  }

  getContext() {
    return this.context
  }

  start = () => new Promise((resolve, reject) => {
    try {
      this.adapter = this.getRecordRTC()
      this.adapter.startRecording()
      resolve()
    } catch (error) {
      reject(error)
    }
  })

  stop = () => new Promise((resolve, reject) => {
    try {
      this.adapter.stopRecording(() => {
        this.stream = this.stream.clone() // This is what makes iOS 11 work!
        resolve(this.adapter.getBlob())
      })
    } catch (error) {
      reject(error)
    }
  })
}
